import * as React from "react";
import { memo, type ReactNode, useMemo } from "react";
import ViewablePackageEntry from "~/features/cart/activeQuote/components/ActiveQuoteReview/ViewablePackageEntry";
import EditablePackageEntry from "~/features/cart/activeQuote/components/productTable/EditablePackageEntry";

interface ActiveQuotePackageEntryListProps {
  packEntryIds: number[];
  editMode?: boolean;
  onRender?: () => void;
}

export const ActiveQuotePackageEntryList = memo(
  ({ packEntryIds, editMode, onRender }: ActiveQuotePackageEntryListProps) => {
    const renderRow: BasePackageEntryListProps["renderRow"] = useMemo(() => {
      if (editMode) {
        return (id: number, index: number) => (
          <EditablePackageEntry key={id} className={"mb-2"} index={index} packEntryId={id} onRender={onRender} />
        );
      } else {
        return (id: number, index: number) => (
          <div key={id} className={"pb-2"}>
            <ViewablePackageEntry packEntryId={id} index={index} />
          </div>
        );
      }
    }, [editMode, onRender]);

    return <BasePackageEntryList packEntryIds={packEntryIds} renderRow={renderRow} />;
  },
);

interface BasePackageEntryListProps {
  packEntryIds: number[];
  renderRow: (packEntryId: number, index: number) => ReactNode;
}

const BasePackageEntryList = React.memo(({ packEntryIds, renderRow }: BasePackageEntryListProps) => (
  <div>{packEntryIds.map(renderRow)}</div>
));

export default memo(ActiveQuotePackageEntryList);
